import { normalizeResponseBlocks } from '../structured/structuredBlockUtils';

export const REPORT_SECTION_KEYS = {
    EXECUTIVE_SUMMARY: 'executive_summary',
    KEY_METRICS: 'key_metrics',
    KEY_FINDINGS: 'key_findings',
    SUPPORTING_EVIDENCE: 'supporting_evidence',
    RISKS_GAPS: 'risks_gaps',
    RECOMMENDATIONS: 'recommendations',
    NEXT_ACTIONS: 'next_actions',
    TIMELINE: 'timeline',
    COMPARISON_TABLES: 'comparison_tables',
    CHECKLISTS: 'checklists',
    APPENDIX: 'appendix',
    UNKNOWN: 'unknown',
};

/** Canonical consultant report section order. */
export const REPORT_SECTION_ORDER = [
    REPORT_SECTION_KEYS.EXECUTIVE_SUMMARY,
    REPORT_SECTION_KEYS.KEY_METRICS,
    REPORT_SECTION_KEYS.KEY_FINDINGS,
    REPORT_SECTION_KEYS.SUPPORTING_EVIDENCE,
    REPORT_SECTION_KEYS.RISKS_GAPS,
    REPORT_SECTION_KEYS.RECOMMENDATIONS,
    REPORT_SECTION_KEYS.NEXT_ACTIONS,
    REPORT_SECTION_KEYS.TIMELINE,
    REPORT_SECTION_KEYS.COMPARISON_TABLES,
    REPORT_SECTION_KEYS.CHECKLISTS,
    REPORT_SECTION_KEYS.APPENDIX,
    REPORT_SECTION_KEYS.UNKNOWN,
];

const BLOCK_SECTION_MAP = {
    executive_summary: REPORT_SECTION_KEYS.EXECUTIVE_SUMMARY,
    kpi_cards: REPORT_SECTION_KEYS.KEY_METRICS,
    key_findings: REPORT_SECTION_KEYS.KEY_FINDINGS,
    markdown: REPORT_SECTION_KEYS.SUPPORTING_EVIDENCE,
    risk_matrix: REPORT_SECTION_KEYS.RISKS_GAPS,
    recommendations: REPORT_SECTION_KEYS.RECOMMENDATIONS,
    timeline: REPORT_SECTION_KEYS.TIMELINE,
    comparison_table: REPORT_SECTION_KEYS.COMPARISON_TABLES,
    checklist: REPORT_SECTION_KEYS.CHECKLISTS,
    expandable_section: REPORT_SECTION_KEYS.APPENDIX,
};

export function resolveBlockReportSection(block) {
    if (!block || typeof block !== 'object') return REPORT_SECTION_KEYS.UNKNOWN;
    const type = String(block.type || '').toLowerCase();
    if (type === 'markdown' && /appendix|supporting evidence|raw evidence/i.test(String(block.title || ''))) {
        return REPORT_SECTION_KEYS.APPENDIX;
    }
    return BLOCK_SECTION_MAP[type] || REPORT_SECTION_KEYS.UNKNOWN;
}

export function createEmptyReportSections() {
    return REPORT_SECTION_ORDER.reduce((acc, key) => {
        acc[key] = [];
        return acc;
    }, {});
}

export function partitionBlocksForReport(blocks) {
    const sections = createEmptyReportSections();
    for (const block of normalizeResponseBlocks(blocks)) {
        sections[resolveBlockReportSection(block)].push(block);
    }
    return sections;
}

export function hasConsultantReportContent(sections, reportActions) {
    const hasBlocks = REPORT_SECTION_ORDER.some(
        key => key !== REPORT_SECTION_KEYS.NEXT_ACTIONS && (sections[key]?.length || 0) > 0,
    );
    return hasBlocks || Boolean(reportActions);
}

export function orderedReportSectionEntries(sections, includeNextActions = false) {
    return REPORT_SECTION_ORDER.filter(key => {
        if (key === REPORT_SECTION_KEYS.NEXT_ACTIONS) return includeNextActions;
        return (sections[key] || []).length > 0;
    }).map(key => ({ key, blocks: sections[key] || [] }));
}
